import { css } from '@emotion/react';
import { DownloadSimple } from '@phosphor-icons/react';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { EditAppSaveButton } from 'client/components/EditApp/EditAppSaveButton';
import { Settings, Section, Actions } from 'client/components/Layout/Settings';
import { Repository } from 'client/sections/repository/Repository';
import { QuickLaunchWarning } from './components/QuickLaunchWarning';
import { SettingsGit } from './components/SettingsGit';

export const DeploymentRepositoryTab = () => {
  const isQuickLaunch = useDeploymentClientState((state) => state.document?.repositoryUrl === null);

  return (
    <Settings css={settingsStyle}>
      <Section title="Repository" subtitle="Configure the Git repositories & branches this deployment pulls its code from.">
        {isQuickLaunch && <QuickLaunchWarning />}
        {!isQuickLaunch && <Repository />}
      </Section>

      <Section
        title="Git Configuration"
        subtitle="Setup automatic Git configuration & access to the project repository."
        inert={isQuickLaunch}
      >
        <SettingsGit />
      </Section>

      <Actions inert={isQuickLaunch}>
        <EditAppSaveButton icon={<DownloadSimple weight="regular" />} primary large>
          Save Changes
        </EditAppSaveButton>
      </Actions>
    </Settings>
  );
};

const settingsStyle = css`
  margin-top: -4rem;
`;
